<template>
  <div class="w-100">
    <div v-t="'biotech_bolt_valassz_atvetelt'" class="py-3 my-3" />
    <button class="custom-button unfilled" v-text="'Legközelebbi bolt'" />
  </div>
</template>

<script>
export default {
  name: 'ShopFinder',
}
</script>

<style lang="scss" scoped>

</style>
